import { getBookmarkedReports, mountFromLocalStorage } from 'client/js/common/actions/ShareableActions';
import { getMicroFrontendsConfig, getMicroFrontendVersions } from 'client/js/main/actions/MicroFrontendActions';
import { hydrate } from 'client/js/redux/domains/FlipperUpdates/actions';
import { getAppAttributionLift } from 'client/js/redux/domains/AppStore/actions';
import { fetchAppsAndOrgs, fetchCurrentOrg } from 'client/js/common/actions/OrgActions';
import { fetchAppCategory } from 'client/js/main/actions/AppCategoryActions';
import { getUserOnboardingData } from 'client/js/common/actions/UserOnboardingDataActions';
import { getDefaultRoles, getUserPermissions } from 'client/js/main/actions/AccessControlActions';
import { loadRole, loadUser } from 'client/js/common/actions/UserActions';
import { AGENCY_VIEW, APP_VIEW } from 'client/js/common/support/viewConstants';
import { fetchCurrentApp } from 'client/js/common/actions/AppActions';
import { getCustomDruidEvents } from 'client/js/common/actions/DruidActions';
import { fetchLinkCreationBlockedStatus } from 'client/js/main/actions/FraudFighterActions';
import { fetchAppStatus } from 'client/js/main/actions/StatusActions';
import { fetchMauCountData, fetchMauLimit, fetchMauOverageCost } from 'client/js/redux/domains/Usage/actions';
import { GetSubscriptions } from 'client/js/main/actions/SubscriptionActions';
import type { DispatchItem } from 'client/js/main/routers/DispatchConfiguration/DispatchItem';
import type { ConditionalDispatchItem } from 'client/js/main/routers/DispatchConfiguration/ConditionalDispatchItem';
import { getUserAppTerms } from 'client/js/common/actions/UserEntityTermsActions';
import { fetchEventsPopularity } from 'client/js/main/actions/Events/EventsActions';
import { getCustomCalculations } from 'client/js/main/actions/CustomCalculation/CustomCalculationActions';
import { getAvailableOptimizations } from 'client/js/redux/domains/SKANConversionValueMapping/actions';
import { PAM, SKAN_CONVERSION_CENTER_IMPROVED_MAPPINGS } from '../../../../../shared/constants/flipperFlags';

export const ESSENTIAL_DISPATCHES: ConditionalDispatchItem[] = [
  // APP_VIEW & ORG_VIEW
  { toDispatch: fetchAppsAndOrgs },
  { toDispatch: fetchCurrentOrg },
  { toDispatch: fetchAppCategory },
  { toDispatch: getUserOnboardingData },
  { toDispatch: getDefaultRoles },
  { toDispatch: loadRole },
  { toDispatch: getUserAppTerms },
  {
    toDispatchWithStore: async (store, settings) => {
      const state = await store.dispatch(loadUser());
      store.dispatch(getUserPermissions(state.agency_user, settings.view.current_view === AGENCY_VIEW));
    },
  },
  {
    toDispatchWithStore: (store) => {
      store.dispatch(GetSubscriptions.request());
    },
  },
  // APP_VIEW only
  { toDispatch: fetchCurrentApp, view: APP_VIEW },
  { toDispatch: fetchAppStatus, view: APP_VIEW },
  { toDispatch: fetchMauLimit, view: APP_VIEW },
  { toDispatch: fetchLinkCreationBlockedStatus, view: APP_VIEW },
  { toDispatch: fetchMauCountData, view: APP_VIEW },
  { toDispatch: fetchMauOverageCost, view: APP_VIEW },
  { toDispatch: getAvailableOptimizations, view: APP_VIEW, flipper: SKAN_CONVERSION_CENTER_IMPROVED_MAPPINGS },
];

export const WIDELY_USED_DISPATCHES: ConditionalDispatchItem[] = [
  // APP_VIEW & ORG_VIEW
  { toDispatch: getMicroFrontendVersions },
  { toDispatch: getMicroFrontendsConfig },
  // APP_VIEW only
  { toDispatch: getCustomDruidEvents, view: APP_VIEW },
  { toDispatch: getBookmarkedReports, view: APP_VIEW },
  { toDispatch: getCustomCalculations, view: APP_VIEW },
  { toDispatch: getAppAttributionLift, view: APP_VIEW, flipper: PAM },
  {
    toDispatchWithStore: async (store) => {
      const user = await store.dispatch(loadUser());
      store.dispatch(fetchEventsPopularity(user?.agency_user));
    },
    view: APP_VIEW,
  },
];

export const NON_API_DISPATCHES: DispatchItem[] = [{ toDispatch: mountFromLocalStorage }, { toDispatch: hydrate }];
